/** First day of professional career (used across the portfolio). */
export const CAREER_START = '2019-07-01';

/** One digit after the decimal only (e.g. 6.5). */
export const EXPERIENCE_DECIMAL_PLACES = 1;

const MS_PER_YEAR = 365.25 * 24 * 60 * 60 * 1000;

function parseLocalDate(isoDate) {
  const [y, m, d] = isoDate.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/**
 * Elapsed time in fractional years (average year length), e.g. 6.8 for ~6y 9mo.
 * @param {string} isoDate - YYYY-MM-DD
 */
export function decimalYearsSince(isoDate) {
  const start = parseLocalDate(isoDate);
  const diffMs = Date.now() - start.getTime();
  return Math.max(0, diffMs / MS_PER_YEAR);
}

/**
 * @param {string} isoDate - YYYY-MM-DD
 * @returns {string} e.g. "6.5" (always {@link EXPERIENCE_DECIMAL_PLACES} decimal place)
 */
export function formatDecimalYears(isoDate) {
  return decimalYearsSince(isoDate).toFixed(EXPERIENCE_DECIMAL_PLACES);
}

/** Total career length, e.g. "6.5" */
export function careerYearsFormatted() {
  return formatDecimalYears(CAREER_START);
}

function yearWordForDecimalString(d) {
  const n = parseFloat(d);
  return n >= 0.95 && n <= 1.04 ? 'year' : 'years';
}

/**
 * Skill line: "JavaScript (6.5 years)".
 * Pass `fixedYears` for a skill no longer in active use (shown as-is, e.g. "(1 year)").
 */
export function skillWithYears(label, startIso, fixedYears) {
  const d = fixedYears != null ? String(fixedYears) : formatDecimalYears(startIso);
  const unit = yearWordForDecimalString(d);
  return `${label} (${d} ${unit})`;
}
